
const connections = require('../connections');



const cobs = {
  fbl: {
    options: {
      serviceAccount: require('./fb/fid-sql-fb.json')
    }
  }
}

const getConnection = ({ modes, log }) => {

  const connectionType = 'fb';
  // standard checking that we are connecting to the right thing
  const {
    howToConnect,
    mode
  } = connections.checkConnection ({modes, log, connectionType});

  // connection object specific to this type
  const targetMode = cobs[mode];


  return {
    needIngress: false,
    host: null,
    options: targetMode.options,
    howToConnect
  }

}
export  {
  getConnection
};